import TagManager from 'react-gtm-module';

/** The page type a Rich Content Block is tracked on. */
export type RichContentBlockLocation = 'cip' | 'clp' | 'homepage';

export interface TrackRichContentBlockViewProps {
  interactionLocation: RichContentBlockLocation;
  /** Path the block was seen on, without its query string. */
  eventPage: string;
  /** What identifies the block, e.g. `heading: …` or `img: …` (see
      `richContentBlockHeading`), or `null` when it has nothing to show */
  heading: string | null;
  /** 0-based position among the page's Rich Content Blocks */
  index: number;
}

/**
 * ED-592 — a Rich Content Block scrolling into view on a CIP, CLP or the
 * homepage.
 */
export const trackRichContentBlockView = ({
  interactionLocation,
  eventPage,
  heading,
  index,
}: TrackRichContentBlockViewProps) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'view_component',
      interaction: {
        interaction_location: interactionLocation,
        type: 'rich_content',
        heading,
        event_page: eventPage,
        // Sent as a string to match the ticket spec and the other events.
        index: index.toString(),
      },
    },
  });
};
